import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  getFeatureFlagFromParams,
  isFeatureFlagEnabled,
  setFeatureFlagCookie,
} from "@/react/utils/featureFlagCookies";

const COOKIE_NAME = "new_onboarding";

/**
 * Hook to manage the new onboarding flow state through URL parameter and cookie
 * @returns boolean indicating if the new onboarding flow should be used
 */
const useIsNewOnboardingFlow = (): boolean => {
  const [isNewOnboardingFlow, setIsNewOnboardingFlow] = useState(false);
  const { search } = useLocation();

  useEffect(() => {
    const paramValue = getFeatureFlagFromParams(search, "new_onboarding");

    if (paramValue !== null) {
      setFeatureFlagCookie(COOKIE_NAME, paramValue);
      setIsNewOnboardingFlow(paramValue === "true");
    } else {
      setIsNewOnboardingFlow(isFeatureFlagEnabled(COOKIE_NAME));
    }
  }, [search]);

  return isNewOnboardingFlow;
};

export default useIsNewOnboardingFlow;
